<template>
  <div class="ag-title relative flex"
       :class="`ag-title--${size}`"
       style="width: fit-content;flex: fit-content;"
       :style="{'justify-content' : align}">
    <html-title :level="level" class="title inline-block relative bold margin-remove "
                :class="`c-${textTheme}`">
      <span v-if="text || $slots['default']" class="title-text relative text-max">
        <slot>
          {{ tt(text) }}
        </slot>
      </span>
      <div class="decoration" :class="`bg-${theme}`"></div>
    </html-title>

  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: [String, Boolean],
      default: false,
    },
    align: {
      type: String,
      default: "inline-start",
    },
    textTheme: {
      type: [String],
      default: "text",
    },
    level: {
      type: [String, Number],
      default: "1",
    },
    theme: {
      type: [String],
      default: "alt",
    },
    size: {
      type: String,
      default: "l"
    }
  },
  data: function () {
    return {};
  },
};
</script>

<style scoped lang="scss">
.title-text {
  z-index: var(--z-2);
}

.decoration {
  position: absolute;
  z-index: var(--z-1);
  bottom: calc(0.2em - 1px);
  height: 11px;
  width: calc(100% + 0.3em);
  inset-inline-start: -0.15em;
  border-radius: 0.5em;

  .ag-title--s &, .ag-title--small & {
    bottom: calc(2px);
    height: 4px;
  }

}
</style>
